import { parseToItems } from 'utils/parseToItems';

import useTranslation from 'components/fields/ClientSelectPanelField/hooks/useTranslation';

import useClients from 'hooks/useClients';
import useSelectPanelField from 'hooks/useSelectPanelField';

import { DEFAULT_PAGE_SIZE } from './constants';
import type { ClientResponse } from './types';

const useData = () => {
    const { fetch, isLoading, reset } = useClients();

    const { NO_CLIENTS_FOUND } = useTranslation();

    const { handleAsyncFilter, hasNextPage, items, noItemsText, onNextPage } =
        useSelectPanelField<ClientResponse>({
            fetchFn: fetch,
            noItemsFoundText: NO_CLIENTS_FOUND,
            pageSize: DEFAULT_PAGE_SIZE,
            parseFn: parseToItems,
            resetFn: reset
        });

    return {
        clientItems: items,
        handleAsyncFilter,
        hasNextPage,
        isLoading,
        noItemsText,
        onNextPage
    };
};

export default useData;
